var debounce = require('lodash/debounce');
const createSwiper = require('../../../components/swiperFactory');
const getAnalyticsEventCenter = require('../../../common/getAnalyticsEventCenter');

const analyticsEventCenter = getAnalyticsEventCenter();

/**
 * Calculate slider speed.
 *
 * @param {Object} container Slider container
 * @return {int} Swiper speed

 */
function calculateSpeed(container) {
    var speed = container.data('speed');
    switch (speed) {
        case 'slow':
            return 4000;
        case 'medium':
            return 2500;
        case 'fast':
            return 1050;
        default:
            return 2500;
    }
}

/**
 * Init swiper slider.
 *
 * @param {Element|string} container - HTMLElement or string (with CSS
 * Selector) of swiper container HTML element. Required.
 * @returns {Promise.<Object>} - Swiper instance
 */
async function swiperInit(container) {
    return createSwiper(container, {
        direction: 'horizontal',
        slidesPerView: 1,
        slidesPerColumn: 1,
        spaceBetween: 12,
        grabCursor: true,
        loop: true,
        speed: calculateSpeed(container),
        updateOnWindowResize: true,
        autoplay: true,
        delay: 3000,
        pagination: {
            el: '.pd-image-carousel__pagination',
            type: 'fraction'
        },
        navigation: {
            nextEl: '.pd-image-carousel__swiper-button-next',
            prevEl: '.pd-image-carousel__swiper-button-prev'
        },
        on: {
            loopFix: function () {
                const loadingImages = container.find('.lazyloading');
                loadingImages?.each(function () {
                    if ($(this).attr('src')) {
                        $(this).removeClass('lazyloading').addClass('lazyloaded');
                    }
                });
            },
            slideChange: function () {
                analyticsEventCenter.publish(
                    analyticsEventCenter.EVENTS.sliderActiveSlideChanged,
                    this
                );
            }
        }
    });
}

/**
 * Calculate slider arrow position.
 *
 * @param {Object} container Slider container
 */
function calculateArrowsPosition(container) {
    var imageHeight = container.find('.pd-image-carousel-slide__image').outerHeight();
    if (imageHeight !== 0) {
        container.children('.swiper-button-next').css('top', imageHeight / 2 + 'px');
        container.children('.swiper-button-prev').css('top', imageHeight / 2 + 'px');
    }
}

/**
 * Initializes slider, calculates arrow position,
 * manages title and subtitle and sets resize event
 * @param {Element} sliderContainer - slider container
 * @returns {Promise.<Object>} - Swiper instance
*/
function initializeSlider(sliderContainer) {
    return swiperInit(sliderContainer).then(function (swiper) {
        if (sliderContainer.find('.pd-image-carousel-slide')) {
            calculateArrowsPosition(sliderContainer);

            if ($('.pd-image-carousel-slide__title-wrapper')) {
                $('.pd-image-carousel-slide__title-wrapper').addClass('swiper-slide-caption');
            }

            if ($('.pd-image-carousel-slide__subtitle')) {
                $('.pd-image-carousel-slide__subtitle').addClass('swiper-slide-caption__subtitle');
            }

            $(window).on('resize', debounce(function () {
                calculateArrowsPosition(sliderContainer);
            }, 300));
        }
        return swiper;
    });
}

jQuery(document).ready(function () {
    $('.pd-image-carousel__swiper-container').each(function () {
        var container = $(this);

        if (container.find('.pd-image-carousel__slide-item').length > 1) {
            var slider = $(this);

            var sliderObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.intersectionRatio > 0) {
                        $.when(initializeSlider($(entry.target))).then(function () {
                            sliderObserver.unobserve(entry.target);
                        });
                    }
                });
            }, { threshold: 0 });

            sliderObserver.observe(slider[0]);
        }
    });
});
